import React, { FC } from 'react';

import { RichText } from '../RichText/RichText';

import { HeadersWithDescriptionProps } from './HeadersWithDescription.types';

import * as styles from './HeadersWithDescription.module.scss';

export const HeadersWithDescription: FC<HeadersWithDescriptionProps> = ({
    description,
    title,
    titleSize,
    subtitle,
    subtitleSize,
    descriptionSize,
    contentAlignment,
}) => {
    return (
        <div className={styles[contentAlignment]}>
            {title && <RichText content={title} textSize={titleSize} noHeaderMargin={!subtitle && !description} />}
            {subtitle && <RichText content={subtitle} textSize={subtitleSize} />}
            {description && <RichText content={description} textSize={descriptionSize} />}
        </div>
    );
};
